<template>
  <section
    :id
    :class="{
      container: !parentType,
    }"
    class="paragraph-accordion"
  >
    <Accordion :title="title" :is-open="isOpen">
      <BlokkliField
        name="field_paragraphs"
        :list="filterNullArray(paragraphs)"
        :should-render-item
        :class="{
          'min-h-24': isEditing,
        }"
      />
    </Accordion>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphAccordionFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

defineProps<{
  title?: string
  paragraphs?: ParagraphAccordionFragment['paragraphs']
}>()

const { index, siblings, parentType } = defineBlokkli({
  bundle: 'accordion',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  propsFieldMapping: {
    paragraphs: { type: 'field', name: 'field_paragraphs' },
    title: {
      type: 'editable',
      name: 'field_title',
    },
  },
})

const id = useParagraphAnchorId(index, siblings)
const isEditing = false
const { shouldRenderItem } = useParagraphVisiblity()

const open = ref(false)

const isOpen = computed(() => open.value || !!isEditing)
</script>

<style lang="postcss">
.paragraph-accordion + .paragraph-accordion > .accordion {
  @apply border-t-0;
}
</style>
